/**
 * src/domains/jobs/jobs.store.ts
 *
 * Reactive store for marketplace jobs.
 * Uses createStore factory for sessionStorage caching.
 */
import { createStore } from '../../infra/sync';

import { fetchOpenJobs, fetchMyJobs } from './jobs.api';
import type { Job } from './jobs.types';

export interface JobState {
  jobs: Job[];
  myJobs: Job[];
  loading: boolean;
  error: string | null;
}

export const jobStore = createStore<JobState>({
  cacheKey: 'pioneer_marketplace_jobs',
  initialValue: { jobs: [], myJobs: [], loading: false, error: null },
});

export async function loadJobs(category?: string): Promise<void> {
  jobStore.patchState({ loading: true, error: null });
  try {
    const jobs = await fetchOpenJobs(category);
    jobStore.patchState({ jobs, loading: false });
  } catch (err) {
    jobStore.patchState({
      loading: false,
      error: err instanceof Error ? err.message : 'Failed to load jobs',
    });
  }
}

export async function loadMyJobs(): Promise<void> {
  jobStore.patchState({ loading: true, error: null });
  try {
    const myJobs = await fetchMyJobs();
    jobStore.patchState({ myJobs, loading: false });
  } catch (err) {
    jobStore.patchState({
      loading: false,
      error: err instanceof Error ? err.message : 'Failed to load my jobs',
    });
  }
}
